import { html, nothing } from 'lit';
import { property } from 'lit/decorators.js';
import type { ChoicePresentation } from '../../core/protocol/types';
import { toolStyles } from '../styles';
import { ToolElement } from './base';
import { rightIcon } from '../icons';
export class OsviButtons extends ToolElement {
  static styles = toolStyles;
  protected readonly toolType = 'ui_buttons';
  @property() variant: 'chips' | 'list' = 'chips';
  render() {
    const i = this.interaction;
    if (!i) return nothing;
    if (!this.valid) return html`<p>${i.content}</p>`;
    const p = i.presentation as ChoicePresentation;
    const chosen = i.response_payload?.kind === 'text' ? i.response_payload.value : p.options.find(o => o.id === (i.response_payload?.kind === 'selection' ? i.response_payload.value : i.selected_option_id))?.label;
    return html`<p class="label">${p.label}</p>${p.description ? html`<p class="description">${p.description}</p>` : nothing}
      ${this.live || this.readonly ? html`<div role="group" aria-label="Options" class=${this.variant} @keydown=${this.onKey}>
        ${p.options.map(o => html`<button type="button" ?disabled=${!this.live} @click=${() => this.pick(o.id, o.allow_input, o.input_placeholder)}><span class="text"><span>${o.label}</span>${o.description ? html`<small>${o.description}</small>` : nothing}</span>${this.variant === 'list' ? rightIcon : nothing}</button>`)}
      </div>` : chosen ? html`<p class="answer">${chosen}</p>` : nothing}`;
  }
  private pick(id: string, allowInput?: true, placeholder?: string) {
    if (!this.live || !this.valid || !this.interaction) return;
    if (this.interaction.schema_version === 2 && allowInput) {
      this.dispatchEvent(new CustomEvent('osvi-request-input', { bubbles: true, composed: true, detail: { interactionId: this.interaction.interaction_id, placeholder } }));
    } else this.respond({ kind: 'selection', value: id });
  }
  private onKey(e: KeyboardEvent) {
    if (!['ArrowDown', 'ArrowUp', 'ArrowRight', 'ArrowLeft'].includes(e.key)) return;
    const list = [...this.renderRoot.querySelectorAll('button')];
    const at = list.indexOf((this.renderRoot as ShadowRoot).activeElement as HTMLButtonElement);
    const step = e.key === 'ArrowDown' || e.key === 'ArrowRight' ? 1 : -1;
    list[(at + step + list.length) % list.length]?.focus(); e.preventDefault();
  }
}
